import TacDialog from './TacDialog';
import {
	connect
} from 'react-redux';
import {
	toggleTacCheckbox,
	tacSubmit
} from '../../actions';


const mapStateToProps = (state) => ({
	isTacAccepted: false,
	isTacChecked: state.tacRed.isTacChecked
});

const mapDispatchToProps = (dispatch) => ({
	onTacCheckboxChanged: (bool) => {
		dispatch(toggleTacCheckbox(bool))
	},
	onTacSubmit: () => {
		dispatch(tacSubmit())
	}
});

const TacDiagConnect = connect(
	mapStateToProps,
	mapDispatchToProps
)(TacDialog);


export default TacDiagConnect;


/** WEBPACK FOOTER **
 ** ./src/components/Tac/TacDialogConnect.js
 **/